/**
 * Column 2: Possible (blue) and not-possible (red) drivers per trip. Click driver to show detail in column 3.
 */

import React from 'react';

export default function PossibleDriversList({
  tripId,
  driverIds,
  rejectedReasons,
  driversMap,
  selectedDriverId,
  selectedTripId,
  onSelectDriver,
}) {
  const possibleIds = new Set(driverIds || []);
  const rejectedIds = rejectedReasons ? Array.from(rejectedReasons.keys()) : [];

  const possibleDrivers = (driverIds || []).map((id) => driversMap?.[id]).filter(Boolean);
  const rejectedDrivers = rejectedIds.map((id) => driversMap?.[id]).filter(Boolean);

  const isRelevant = selectedTripId === tripId;

  return (
    <div className="flex flex-wrap gap-1.5">
      {possibleDrivers.map((driver) => {
        const id = String(driver.driver_id || driver.id || '');
        const name = driver.driver_name || driver.displayName || id;
        const isSelected = isRelevant && selectedDriverId === id;

        return (
          <button
            key={`ok-${id}`}
            type="button"
            onClick={() => onSelectDriver?.(id)}
            className={`px-2 py-1 rounded-[4px] text-[9px] font-black uppercase tracking-tight transition-all border shadow-sm ${
              isSelected
                ? 'bg-main-primary text-white border-main-primary ring-2 ring-main-primary/20'
                : 'bg-indigo-50 text-indigo-700 border-indigo-100 hover:bg-white hover:border-indigo-300'
            }`}
          >
            {name}
          </button>
        );
      })}
      {rejectedDrivers.map((driver) => {
        const id = String(driver.driver_id || driver.id || '');
        const name = driver.driver_name || driver.displayName || id;
        const isSelected = isRelevant && selectedDriverId === id;

        return (
          <button
            key={`rej-${id}`}
            type="button"
            onClick={() => onSelectDriver?.(id)}
            className={`px-2 py-1 rounded-[4px] text-[9px] font-black uppercase tracking-tight transition-all border shadow-sm ${
              isSelected
                ? 'bg-rose-600 text-white border-rose-600 ring-2 ring-rose-600/20'
                : 'bg-rose-50 text-rose-600 border-rose-100 hover:bg-white hover:border-rose-300'
            }`}
          >
            {name}
          </button>
        );
      })}
      {possibleDrivers.length === 0 && rejectedDrivers.length === 0 && (
        <div className="text-[10px] text-gray-400 font-bold uppercase italic py-1">No drivers identified</div>
      )}
    </div>
  );
}
